import React, { FC, useEffect, useState } from 'react';
import { FormControl, InputLabel, OutlinedInput, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import Employee from '../../../../../../../interfaces/api/Employee';
import useEmployeeAccess from '../../../../../../../hooks/api/useEmployeeAccess';

interface Props {
  value?: string;
  onChange: (value: string) => void;
}

const EmployeeSelect: FC<Props> = ({ onChange, value }) => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  const { getAll } = useEmployeeAccess();

  useEffect(() => {
    getAll()
      .then((collection) => {
        setEmployees(collection.items);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const value = event.target.value as string;

    if (value) {
      onChange(value);
    }
  };

  const handleSortEmployee = (employeeA: Employee, employeeB: Employee) => {
    return `${employeeA.firstname} ${employeeA.lastname}`.localeCompare(`${employeeB.firstname} ${employeeB.lastname}`);
  };

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <FormControl variant='outlined' fullWidth>
      <InputLabel shrink>Employé</InputLabel>
      <Select native value={value} onChange={handleChange} input={<OutlinedInput notched label='Employé' />}>
        <option value='' />
        {employees.sort(handleSortEmployee).map((employee, key) => (
          <option key={key} value={employee.id}>
            {`${employee.firstname} ${employee.lastname}`}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default React.memo(EmployeeSelect);
